import { Component, type OnDestroy, OnInit } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';
import { ReplaySubject, takeUntil } from 'rxjs';
import { CustomerFormFacade } from '../../../+state/customer-form/customer-form.facade';

@Component({
  selector: 'xilo-mono-form-viewer-customer-repeat',
  templateUrl: './customer-repeat.component.html'
})
export class CustomerRepeatTypeComponent extends FieldArrayType implements OnInit, OnDestroy {
  subsection = 0;
  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(private customerFormFacade: CustomerFormFacade) {
    super();
  }

  ngOnInit() {
    if (this.field.fieldGroup && this.field.fieldGroup.length === 0) {
      setTimeout(() => {
        try {
          this.add();
          // This is a temporary hack for when a current submissions is being edited which was not formatted properly
          // including an empty array for the section
          setTimeout(() => {
            if (this.field.formControl['controls']?.length === 0 && !this.field.templateOptions.hidden) {
              this.add();
            }
          }, 1000);
        } catch (error) {
          console.error(error);
        }
      }, 200);
    }
    this.field.templateOptions = {
      ...this.field.templateOptions,
      onAdd: () => {
        this.add();
      },
      onRemove: (index: number) => {
        this.remove(index);
      }
    };
    this.customerFormFacade.subsectionIndex$.pipe(takeUntil(this.destroyed$)).subscribe(index => {
      this.subsection = index;
    });
  }

  trackByFieldId(index: number, field: FormlyFieldConfig): string | number {
    return field?.id || index;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}
